import { AgGridColumnDef } from '@tassat/common-definitions';

export const readonlyFirmAccountWalletsColumnDefs: AgGridColumnDef[] = [
    {
        field: 'AccountName',
        headerName: 'Account Name',
        headerValueGetter: (params) => (params.api.getDisplayedRowCount() ?
            `${params.api.getDisplayedRowCount()} Account${params.api.getDisplayedRowCount() !== 1 ? 's' : ''}`
            : 'Account Name'),
        cellRenderer: 'walletNameCellRenderer',
        menuTabs: ['filterMenuTab'],
        flex: 5
    },
    {
        field: 'Account',
        headerName: 'Account Address',
        cellRenderer: 'addressCellRenderer',
        menuTabs: [],
        flex: 4
    },
    {
        field: 'IsPrimary',
        headerName: 'Primary Account',
        cellRenderer: 'isPrimaryCellRenderer',
        menuTabs: [],
        flex: 2
    }
];